<template>
  <div class="form-item-container" :class="{ 'first-form-item': form_item_order === 0 && layout_mode === 'all_on_one_page' }">
    <div class="questions-container">
      <div class="question-primary-language">
        {{ question_lang1 }}
      </div>
      <div class="question-secondary-language" v-if="bilingue">
        {{ question_lang2 }}
      </div>
    </div>
    <div class="references-container">
      <div v-for="(option, index) in options" :key="index" class="reference">
        <span class="reference-primary-language">{{ option.text_lang1 }}</span>
        <span class="reference-secondary-language" v-if="bilingue">{{ option.text_lang2 }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { FormItemOption } from '@/utils/DataTypes'

export default {
  name: 'NavigationItem',
  props: {
    question_lang1: {
      type: String,
      default: ''
    },
    question_lang2: {
      type: String,
      default: ''
    },
    bilingue: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array as () => Array<FormItemOption>,
      default: () => []
    },
    form_item_id: {
      type: Number,
      default: 0
    },
    form_item_order: {
      type: Number,
      default: -1
    },
    layout_mode: {
      type: String,
      default: 'all_on_one_page'
    }
  },
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.form-item-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  width: 100%;
  padding: 2em 5% 2em 5%;
  color: $gorate-secondary;

  .questions-container {
    grid-row: 1;

    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr auto;

    align-items: center;
    justify-items: center;

    .question-primary-language {
      grid-row: 1;
      font-size: clamp(1.5em, 1vw + 1rem, 2em);
      font-weight: bold;
      padding-bottom: 0.2em;
    }

    .question-secondary-language {
      grid-row: 2;
      font-size: clamp(1em, 0.5vw + 1rem, 1.5em);
    }
  }

  .references-container {
    grid-row: 2;
    display: grid;
    grid-template-columns: 1fr;
    gap: 1em;
    padding: 1em;
    align-items: center;
    justify-content: center;

    .reference {

      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: 1fr auto;

      text-align: center;

      max-width: 100%;
      max-height: 30em;

      padding: 0.5em 0;

      background-color: $gorate-medium;
      border-radius: 23px;
      border: 4px solid transparent;

      cursor: pointer;

      .reference-primary-language {
        grid-row: 1;
        font-size: clamp(1.4em, 0.9vw + 1rem, 1.9em);
        padding-bottom: 0.2em;
        font-weight: bold;
      }

      .reference-secondary-language {
        grid-row: 2;
        font-size: clamp(1.2em, 0.8vw + 1rem, 1.5em);
      }
    }

    .clicked {
      border: 4px solid $gorate-secondary;
    }
  }
}

.form-item-container.first-form-item {
  .references-container {
    .reference-primary-language {
      color: #000;
    }

    .reference-secondary-language {
      color: #000;
    }
  }
}
</style>
